import script from "./LevelChange.vue?vue&type=script&setup=true&lang=ts"
export * from "./LevelChange.vue?vue&type=script&setup=true&lang=ts"

import "./LevelChange.vue?vue&type=style&index=0&id=59dee117&lang=scss"

const __exports__ = script;

export default __exports__